
module.exports = {
	BASE_URL: 'http://118.27.192.118:9091/v1',
	SOCKET_SERVER_URL: 'https://api.longthanhtc.com',
};

